

define('eteration/widgets/ui-wingosharebox',['jquery', 
        'knockout',
        'eteration/eteration-ajax',
		'eteration/widgets/ui-i18n',
		'eteration/eteration',
		'eteration/eteration-i18n',
		'eteration/ui/validation-helper',
		'common/recaptcha-constants'
        ], function($, ko, etrAjax, ui18, Eteration, i18n, validation, recaptchaConstants){
	
	i18n.loadMsgs([ 'common', 'lookup' ], null, 'wingosharebox');
	
	function WingoShareBox() {
		
		var self = this;
		var language = "en";
		var country = "US";
		var pubid = "40";
		
		self.langCountryCode = $('meta[name=languagecountry]').attr("content");
		if(self.langCountryCode != null && self.langCountryCode != "")
			{
			var langCountry = self.langCountryCode;
			var langCountryPair  = langCountry.split("-"); 
			if(langCountryPair.length == 2)
				{	
				language = langCountryPair[0];
				country = langCountryPair[1];
				}
			}
		
		pubid = $('meta[name=PublicationID]').attr("content");
		if(pubid == null || pubid == "")
			pubid = "40";
		
	    ko.wingosharebox = {
	        viewModel: function (configuration) {
	        	
	        	var self = this;
	        	self.visibility = configuration.visibility;
	        	
	        	self.fromEmail = ko.observable("");
	    		self.email = ko.observable("");
	    		self.subject = ko.observable("");
	    		self.mailBody = ko.observable("");
	    		self.mailBodyWithUrl = ko.observable("");
	    		self.language = ko.observable("");
	    		self.showSuccess = ko.observable(false);
	    		self.showFailure = ko.observable(false);
	    		self.url = ko.observable("http://");
	    		self.cbselected = ko.observable(true);
	    		self.sendBtnDisabled= ko.observable(false);
	    		
	    		function ReCaptchaInfo(){
	                var self = this;
	                self.privateKey = ko.observable();
	                self.remoteIp = ko.observable();
	                self.challenge = ko.observable();
	                self.response = ko.observable();
	            }
	    		
	    		self.recaptchaInfo = ko.observable(new ReCaptchaInfo());
	    		
	    		self.validationContext = ko.jqValidation({
	    			customValidators : {
	    		    	fromEmailRequirementValidator: function(el) {
	    		    		var email = self.fromEmail();
	    		    		if(!email) {
	    		    			var errorMessage = validation.validators["required"](el);
	    		    			return errorMessage;
	    		    		}
	    		    		else {
	    		    			var errorMessage = validation.validators["email"](el);
	    		    			return errorMessage;
	    	    			}
	    		    	},
	    		    	toEmailRequirementValidator: function(el) {
	    		    		var email = self.email();
	    		    		if(!email) {
	    		    			var errorMessage = validation.validators["required"](el);
	    		    			return errorMessage;
	    		    		}
	    		    		else {
	    		    			var errorMessage = validation.validators["email"](el);
	    		    			return errorMessage;
	    	    			}
	    		    	},
	    		    	mailBodyRequireValidator: function(el) {
	    					var mailBody = self.mailBody();
	    					if(typeof(mailBody) == "undefined") {
	    						return i18n.get("ERR-MS-LOGIN-380");
	    					}
	    					else if(mailBody == null) {
	    						return i18n.get("ERR-MS-LOGIN-380");
	    					}
	    					else if(mailBody.length == 0) {
	    						return i18n.get("ERR-MS-LOGIN-380");
	    					}
	    				}
	    		    },
                    postValidators:[{
                        name:"captcha",
                        id:"captcha",
                        func:function() {
                            if(($("#g-recaptcha-response-1").length && !$("#g-recaptcha-response-1").val().length) || (!$("#g-recaptcha-response-1").length && (!$("#g-recaptcha-response").length || !$("#g-recaptcha-response").val().length))) {
                                return i18n.get("ERR-MS-LOGIN-380");
                            }

                        }
                    }]
	    		});
	    		
	    		
	    		self.shareViaEmail = function() {
	    			var wingoUrl = self.url();
	    			var validationResult = self.validationContext.Validate();
	    			var checkSendCopy = self.cbselected();
		    		self.sendBtnDisabled(true);	

	    			
	    			self.subject(i18n.get("Label-DEST-600"));
	    			self.mailBody(i18n.get("Label-DEST-601"));
	    			
	    			var getHostName = window.location.hostname;
	    			var sharedURL = "<a href='"+wingoUrl+"'>" + wingoUrl + "</a>";
	    			
	    			var bodymessage = "<p>" + self.mailBody() + "<br><br>" + sharedURL + "</p>";
	    			
	    			if($("#g-recaptcha-response-1").length > 0){
                        self.recaptchaInfo().response($("#g-recaptcha-response-1").val());
                    } else {
                        self.recaptchaInfo().response($("#g-recaptcha-response").val());
                    }
	    			
	    			var uiMap = {
                        'captchaError': 'captchaError'
                    }

	    			if(validationResult.valid){
     	 				etrAjax.post({
    						app : 'app.ibs',
    						service : '/booking/sendMailFromWingo',
    						disableLoader : true,
    						data :{"from": self.fromEmail(),"to":self.email(),"subject":self.subject(),"content":bodymessage,"wingoUrl":wingoUrl, "sendCopy":self.cbselected(), recaptchaInfo: JSON.parse(ko.toJSON(self.recaptchaInfo()))},
    						callback : function(response) {
    							if(response.data){
    								self.showSuccess(true);
    								self.showFailure(false);
    								setTimeout(function(){
    								        $('#emailPanelId').modal('hide'); 
    								        self.sendBtnDisabled(false);
    								    
    								},4000);
    							}
    							else{
    								self.showFailure(true);
    								self.showSuccess(false);
    								self.sendBtnDisabled(false);
    							}
    						},
    						error:function(data){
    						    console.info(data);
    						}
    						
    					});
	    			}
	    			else{
	    			    self.showFailure(true);
						self.showSuccess(false);
						self.sendBtnDisabled(false);
	    			}
	    		
	    			grecaptcha !== 'undefined' && grecaptcha.reset();
	    		}
	    		
	    		self.openWingoShareBox = function() {
	            	self.fromEmail("");
	        		self.email("");
	        		self.subject("");
	        		self.mailBody("");
	        		self.mailBodyWithUrl("");
	        		self.language("");
	        		self.showSuccess(false);
	        		self.showFailure(false);
	        		self.cbselected(false);
	    			
	    			$('#emailPanelId').modal('show');
	    		}
	    		
	    		self.addCaptcha = function () {
	                var addedHtmlHeadScript = '<script src="' + recaptchaConstants.domain + '?onload=myCallBack&render=explicit&hl=' + i18n.getUserLocale() + '" async defer></script>';
	                addedHtmlHeadScript += '<script>';
	                addedHtmlHeadScript += 'var recaptcha;';
	                addedHtmlHeadScript += 'var myCallBack = function() {';
	                addedHtmlHeadScript += 'setTimeout(function(){';
	                addedHtmlHeadScript += 'if ( $("#captcha").length ) {';
	                addedHtmlHeadScript += 'recaptcha = grecaptcha.render("captcha", {"sitekey" : "6LfvwDMUAAAAALBHKMRVZPZmKygAvKtTQxQ1TCcI","theme" : "light"});';
	                addedHtmlHeadScript += '}';
	                addedHtmlHeadScript += '},3000);';
	                addedHtmlHeadScript += '};</script>';
	                $($('head')[0]).append(addedHtmlHeadScript);
	            }
	    		
	    		self.addCaptcha();
	        }
	    };
	    

	    self.ViewModel = function(configuration) {
	    	return new ko.wingosharebox.viewModel(configuration);
	    }
	    
	    self.templateEngine = new ko.nativeTemplateEngine();
	    self.templateEngine.addTemplate = function(templateName, templateMarkup) {
	    	var templateElement = document.getElementById(templateName);
	    	templateElement.innerHTML = templateMarkup;
	    };

	    self.loadTemplates = function() {

	    	var wingoShareBoxHtml = "\n" +
	    			"<div id=\"emailPanelId\" data-bind=\"jqValidation: validationContext\" class=\"modal fade bs-example-modal-lg hidden-print\" tabindex=\"-1\" role=\"dialog\">\n" +
	    			"	<div class=\"modal-dialog modal-lg\">\n" +
	    			"		<div class=\"modal-content\">\n" +
	    			"			<div class=\"modal-header modal-header-dark\">" +
	    			"				<button  data-bs-dismiss=\"modal\" type=\"button\" class=\"modal-close\">\n" +
	    			"					<i class=\"fa fa-times\"></i>\n" +
	    			"				</button>\n" +
	    			"				<div class=\"h3 text-center\" data-bind=\"i18n-text: {key: 'Label-DEST-558'}\">E-posta ile gönderim</div>\n"+
	    			"			</div>\n"+
	    			"			<div class=\"modal-body card-body\">\n" +
	    			"				<section>\n" +
	    			"					<div class=\"row\">\n" +
	    			"						<div class=\"col-lg-12 col-md-12 col-12\">\n" +
	    			"						\n" +
	    			"							<div class=\"tk-input-field has-feedback has-feedback-lg\">\n" +
	    			"								<div class=\"row\">\n" +
	    			"									<label class=\"col-lg-2 col-md-2 control-label control-label-lg normal\" data-bind=\"i18n-text: {  key: 'Label-DEST-125' }\"></label>\n" +
	    			"									\n" +
	    			"									<div class=\"col-lg-10 col-md-10\">\n" +
	    			"										<input id=\"fromNameId\" maxlength=\"50\" type=\"text\" class=\"form-control input-lg\" data-bind=\"value: fromEmail,attr: {disabled:sendBtnDisabled}\" data-validation=\'{\"required\":true, \"validator\":\"email\"}\' />\n" +
	    			"									</div>\n" +
	    			"								</div>\n" +
	    			"							</div>\n" +
	    			"							\n" +
	    			"							<div class=\"tk-input-field has-feedback has-feedback-lg\">\n" +
	    			"								<div class=\"row\">\n" +
	    			"									<label class=\"col-lg-2 col-md-2 control-label control-label-lg normal\" data-bind=\"i18n-text: {  key: 'Label-DEST-126' }\"></label>\n" +
	    			"									\n" +
	    			"									<div class=\"col-lg-10 col-md-10\">\n" +
	    			"										<input id=\"toNameId\" maxlength=\"50\" type=\"text\" class=\"form-control input-lg input gray\" data-bind=\"value: email,attr: {disabled:sendBtnDisabled}\" data-validation=\'{\"required\":true, \"validator\":\"email\"}\' />\n" +
	    			"									</div>\n" +
	    			"								</div>\n" +
	    			"							</div>\n" +
	    			"                           <div id=\"captcha\"></div> " +
	    			"							\n" +
	    			"						</div>\n" +
	    			"					</div>\n" + 
	    			"					\n" + 
	    			"					<hr>\n" + 
	    			"					<div class=\"row\">\n" + 
	    			"						<div class=\"col-12\">\n" +
	    			"                           <div class=\"col-md-12 col-12 col-lg-9\">\n"+
	    			"                               <div data-bind=\"visible:showSuccess\"><div class=\"alert alert-success\" role=\"alert\"><span data-bind=\"i18n-text: {key: 'Label-DEST-557'}\">İşleminiz başarıyla gerçekleştirildi...</span></div></div>" +
	    			"                               <div data-bind=\"visible:showFailure\"><div class=\"alert alert-warning\" role=\"alert\"><span data-bind=\"i18n-text: {key: 'ERR-GENEL-10'}\">İşleminiz başarısız...</span></div></div>" +			
	    			"                           </div>\n"+
	    			"                           <div class=\"col-md-12 col-12 col-lg-3\">\n"+
	    			"							<div class=\"tk-input-field\">\n" +
	    			"								<a class=\"btn btn-danger fw700 float-end\" data-bind=\"click: shareViaEmail,attr: {disabled:sendBtnDisabled}\">"+
	    			"                                   <span data-bind=\" i18n-text: {  key: 'Label-DEST-130'}\" ></span>\n"+
	    			"                                   <i data-bind=\"visible:sendBtnDisabled \" style=\"position: relative; float: left; display: block; height: 40px; width: 100%; text-align: center;\">\n"+
	    			'                                       <svg id=\"loaderSvg" version="1.1" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <rect x="0" y="13" width="4" height="5" fill="#333"> <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"/> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"/> </rect> <rect x="10" y="13" width="4" height="5" fill="#333"> <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"/> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"/> </rect> <rect x="20" y="13" width="4" height="5" fill="#333"> <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"/> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"/> </rect> </svg>\n'+
	    			"                                   </i>\n"+
	    			"                               </a>\n" +
    			    "						    </div>\n" + 
    			    "						</div>\n" + 
    			    "					</div>\n" +    			
	    		    "				</div>\n" + 
	    			"				\n" + 
	    			"						\n" + 
	    			"				</section>\n" + 
	    			"				\n" + 
	    			"				\n" + 
	    			"			</div>\n" + 
	    			"		</div>\n" + 
	    			"	</div>\n" + 
	    			"</div>\n" + 
	    			"\n" + 
	    			"";

			$('#emailPanelId').modal('show');
		    self.templateEngine.addTemplate("ui_wingoshareBox_tmplt", wingoShareBoxHtml);
	    }
	
	    ko.bindingHandlers.wingosharebox = {
	        init: function(element, viewModelAccessor, allBindings) {
	            return { 'controlsDescendantBindings': true };
	        },
	        update: function (element, viewModelAccessor, allBindings) {
	            var viewModel = viewModelAccessor();
	            var wingoShareBoxTemplateName = "ui_wingoshareBox_tmplt";
	            var wingoShareBoxContainer = element.appendChild(document.createElement("DIV"));
	            ko.renderTemplate(wingoShareBoxTemplateName, viewModel, { templateEngine: self.templateEngine }, wingoShareBoxContainer, "replaceNode");
	        }
	    };
	    
	}
	
	return {
		ViewModel : WingoShareBox
	};
    
	
});
